import { useForm } from '@mantine/form';

import { analyticsTypes } from '../types';

import { DATE_VALUES } from '@/utils/dates';

export const useManagerRepliesForm = () => {
  return useForm<analyticsTypes.GetManagerRepliesParams>({
    initialValues: {
      dateFrom: new Date(),
      dateTo: new Date(),
      interval: 'hour',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      targets: {
        departments: [],
        managers: [],
      },
      isUniqueDialogs: false,
    },

    validate: {
      dateFrom: (date) => (date instanceof Date ? undefined : 'Invalid start of time period'),
      dateTo: (date) => (date instanceof Date ? undefined : 'Invalid end of time period'),
      interval: (interval, values) => {
        if (!interval || !['hour', 'day', 'week', 'month'].includes(interval)) {
          return 'Invalid interval provided';
        }
        const intervalDuration = values.dateTo.valueOf() - values.dateFrom.valueOf();
        const isInvalidInterval =
          (interval === 'month' && intervalDuration > DATE_VALUES.year) ||
          (interval === 'week' && intervalDuration > DATE_VALUES.month * 6) ||
          (interval === 'day' && intervalDuration > DATE_VALUES.month * 3) ||
          (interval === 'hour' && intervalDuration > DATE_VALUES.month);
        if (isInvalidInterval) {
          return 'Interval is not valid for selected date range';
        }
      },
      targets: (targets) =>
        targets.departments.length > 0 || targets.managers.length > 0
          ? undefined
          : 'At least 1 department or employee is required',
    },
  });
};
